export var SopType = /* @__PURE__ */ ((SopType2) => {
  SopType2["PARTICLES_SYSTEM_GPU"] = "particlesSystemGpu";
  SopType2["SHEAR"] = "shear";
  SopType2["TRANSFORM"] = "transform";
  SopType2["UV_LAYOUT"] = "uvLayout";
  SopType2["UV_TRANSFORM"] = "uvTransform";
  SopType2["UV_UNWRAP"] = "uvUnwrap";
  return SopType2;
})(SopType || {});
export var SopTypeFile = /* @__PURE__ */ ((SopTypeFile2) => {
  SopTypeFile2["FILE_DRC"] = "fileDRC";
  SopTypeFile2["FILE_FBX"] = "fileFBX";
  SopTypeFile2["FILE_GLTF"] = "fileGLTF";
  SopTypeFile2["FILE_JSON"] = "fileJSON";
  SopTypeFile2["FILE_MPD"] = "fileMPD";
  SopTypeFile2["FILE_OBJ"] = "fileOBJ";
  SopTypeFile2["FILE_PDB"] = "filePDB";
  SopTypeFile2["FILE_PLY"] = "filePLY";
  SopTypeFile2["FILE_STL"] = "fileSTL";
  SopTypeFile2["FILE_SVG"] = "fileSVG";
  return SopTypeFile2;
})(SopTypeFile || {});
export var SopTypeFileMulti = /* @__PURE__ */ ((SopTypeFileMulti2) => {
  SopTypeFileMulti2["FILE_DRC"] = "fileMultiDRC";
  SopTypeFileMulti2["FILE_FBX"] = "fileMultiFBX";
  SopTypeFileMulti2["FILE_GLTF"] = "fileMultiGLTF";
  SopTypeFileMulti2["FILE_JSON"] = "fileMultiJSON";
  SopTypeFileMulti2["FILE_MPD"] = "fileMultiMPD";
  SopTypeFileMulti2["FILE_OBJ"] = "fileMultiOBJ";
  SopTypeFileMulti2["FILE_PDB"] = "fileMultiPDB";
  SopTypeFileMulti2["FILE_PLY"] = "fileMultiPLY";
  SopTypeFileMulti2["FILE_STL"] = "fileMultiSTL";
  SopTypeFileMulti2["FILE_SVG"] = "fileMultiSVG";
  return SopTypeFileMulti2;
})(SopTypeFileMulti || {});
